import '@angular/compiler';
import { ComponentKieraAssistantWidgetComponent } from './component.kiera.assistant.widget/component.kiera.assistant.widget.component';
import { ComponentKieraRackEditorComponent } from './component.kiera.rack.editor/component.kiera.rack.editor.component';
import { ComponentKieraResourceUsersComponent } from './component.kiera.resource.users/component.kiera.resource.users.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PageKieraComponent } from './page.kiera/page.kiera.component';
import { PageKieraActionsComponent } from './page.kiera.actions/page.kiera.actions.component';
import { PageKieraApiComponent } from './page.kiera.api/page.kiera.api.component';
import { PageKieraAssistantComponent } from './page.kiera.assistant/page.kiera.assistant.component';
import { PageKieraBmcCredentialsComponent } from './page.kiera.bmc.credentials/page.kiera.bmc.credentials.component';
import { PageKieraBmcDiscoveryComponent } from './page.kiera.bmc.discovery/page.kiera.bmc.discovery.component';
import { PageKieraChassisComponent } from './page.kiera.chassis/page.kiera.chassis.component';
import { PageKieraChassisItemComponent } from './page.kiera.chassis.item/page.kiera.chassis.item.component';
import { PageKieraClusterDeployComponent } from './page.kiera.cluster.deploy/page.kiera.cluster.deploy.component';
import { PageKieraClusterDeployItemComponent } from './page.kiera.cluster.deploy.item/page.kiera.cluster.deploy.item.component';
import { PageKieraClusterUsersComponent } from './page.kiera.cluster.users/page.kiera.cluster.users.component';
import { PageKieraClustersComponent } from './page.kiera.clusters/page.kiera.clusters.component';
import { PageKieraClustersItemComponent } from './page.kiera.clusters.item/page.kiera.clusters.item.component';
import { PageKieraDebugComponent } from './page.kiera.debug/page.kiera.debug.component';
import { PageKieraDisklessComponent } from './page.kiera.diskless/page.kiera.diskless.component';
import { PageKieraGroupsComponent } from './page.kiera.groups/page.kiera.groups.component';
import { PageKieraGroupsItemComponent } from './page.kiera.groups.item/page.kiera.groups.item.component';
import { PageKieraHelpComponent } from './page.kiera.help/page.kiera.help.component';
import { PageKieraImagesComponent } from './page.kiera.images/page.kiera.images.component';
import { PageKieraInspectComponent } from './page.kiera.inspect/page.kiera.inspect.component';
import { PageKieraJobsComponent } from './page.kiera.jobs/page.kiera.jobs.component';
import { PageKieraJujuComponent } from './page.kiera.juju/page.kiera.juju.component';
import { PageKieraKeysComponent } from './page.kiera.keys/page.kiera.keys.component';
import { PageKieraLogPolicyComponent } from './page.kiera.log.policy/page.kiera.log.policy.component';
import { PageKieraLogsComponent } from './page.kiera.logs/page.kiera.logs.component';
import { PageKieraLustreComponent } from './page.kiera.lustre/page.kiera.lustre.component';
import { PageKieraManagementSettingsComponent } from './page.kiera.management.settings/page.kiera.management.settings.component';
import { PageKieraNodesComponent } from './page.kiera.nodes/page.kiera.nodes.component';
import { PageKieraNodesApiRegisterComponent } from './page.kiera.nodes.api.register/page.kiera.nodes.api.register.component';
import { PageKieraNodesItemComponent } from './page.kiera.nodes.item/page.kiera.nodes.item.component';
import { PageKieraOperationsRackComponent } from './page.kiera.operations.rack/page.kiera.operations.rack.component';
import { PageKieraPeComponent } from './page.kiera.pe/page.kiera.pe.component';
import { PageKieraProvisioningRackComponent } from './page.kiera.provisioning.rack/page.kiera.provisioning.rack.component';
import { PageKieraRackComponent } from './page.kiera.rack/page.kiera.rack.component';
import { PageKieraRelayComponent } from './page.kiera.relay/page.kiera.relay.component';
import { PageKieraRelayItemComponent } from './page.kiera.relay.item/page.kiera.relay.item.component';
import { PageKieraScriptsComponent } from './page.kiera.scripts/page.kiera.scripts.component';
import { PageKieraSolComponent } from './page.kiera.sol/page.kiera.sol.component';
import { PageKieraSshAccessComponent } from './page.kiera.ssh.access/page.kiera.ssh.access.component';
import { PageKieraStatusComponent } from './page.kiera.status/page.kiera.status.component';
import { PageKieraSubnetsComponent } from './page.kiera.subnets/page.kiera.subnets.component';
import { PageKieraTerminalComponent } from './page.kiera.terminal/page.kiera.terminal.component';
import { PageKieraZabbixComponent } from './page.kiera.zabbix/page.kiera.zabbix.component';
import { PageKieraZonesComponent } from './page.kiera.zones/page.kiera.zones.component';
import { PageMembersComponent } from './page.members/page.members.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PagePostsComponent } from './page.posts/page.posts.component';
import { PagePostsItemComponent } from './page.posts.item/page.posts.item.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
const INDEX_PAGE = "kiera";
const DISABLED_ROUTE_PATHS = new Set(["kiera/status"]);

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let isDisabledRoute = (path: any) => {
    let normalized = String(path || "").replace(/^\/+|\/+$/g, "");
    return DISABLED_ROUTE_PATHS.has(normalized);
};

let app_routes: Routes = [
{ component: LayoutEmptyComponent, children: [
{ path: "access", component: PageAccessComponent },
{ path: "kiera/sol/:nodeId", component: PageKieraSolComponent },
{ path: "kiera/terminal/:nodeId", component: PageKieraTerminalComponent }
] },
{ component: LayoutSidebarComponent, children: [
{ path: "kiera", component: PageKieraComponent },
{ path: "kiera/actions", component: PageKieraActionsComponent },
{ path: "kiera/swagger", component: PageKieraApiComponent },
{ path: "kiera/assistant", component: PageKieraAssistantComponent },
{ path: "kiera/bmc-credentials", component: PageKieraBmcCredentialsComponent },
{ path: "kiera/bmc-discovery", component: PageKieraBmcDiscoveryComponent },
{ path: "kiera/chassis", component: PageKieraChassisComponent },
{ path: "kiera/chassis/:id/:tab?", component: PageKieraChassisItemComponent },
{ path: "kiera/cluster-deploy", component: PageKieraClusterDeployComponent },
{ path: "kiera/cluster-deploy/:id/:tab?", component: PageKieraClusterDeployItemComponent },
{ path: "kiera/cluster-users", component: PageKieraClusterUsersComponent },
{ path: "kiera/clusters", component: PageKieraClustersComponent },
{ path: "kiera/clusters/:id/:tab?", component: PageKieraClustersItemComponent },
{ path: "kiera/debug", component: PageKieraDebugComponent },
{ path: "kiera/diskless", component: PageKieraDisklessComponent },
{ path: "kiera/groups", component: PageKieraGroupsComponent },
{ path: "kiera/groups/:id", component: PageKieraGroupsItemComponent },
{ path: "kiera/help", component: PageKieraHelpComponent },
{ path: "kiera/images", component: PageKieraImagesComponent },
{ path: "kiera/inspect", component: PageKieraInspectComponent },
{ path: "kiera/jobs", component: PageKieraJobsComponent },
{ path: "kiera/juju", component: PageKieraJujuComponent },
{ path: "kiera/keys", component: PageKieraKeysComponent },
{ path: "kiera/log-policy", component: PageKieraLogPolicyComponent },
{ path: "kiera/logs", component: PageKieraLogsComponent },
{ path: "kiera/lustre", component: PageKieraLustreComponent },
{ path: "kiera/management-settings", component: PageKieraManagementSettingsComponent },
{ path: "kiera/nodes", component: PageKieraNodesComponent },
{ path: "kiera/nodes/api-register", component: PageKieraNodesApiRegisterComponent },
{ path: "kiera/nodes/:id/:tab?", component: PageKieraNodesItemComponent },
{ path: "kiera/operations-rack", component: PageKieraOperationsRackComponent },
{ path: "kiera/pe", component: PageKieraPeComponent },
{ path: "kiera/provisioning-rack", component: PageKieraProvisioningRackComponent },
{ path: "kiera/resourcerack", component: PageKieraRackComponent },
{ path: "kiera/relay", component: PageKieraRelayComponent },
{ path: "kiera/relay/:id", component: PageKieraRelayItemComponent },
{ path: "kiera/scripts", component: PageKieraScriptsComponent },
{ path: "kiera/ssh-access/:key?", component: PageKieraSshAccessComponent },
{ path: "kiera/status", component: PageKieraStatusComponent },
{ path: "kiera/subnets", component: PageKieraSubnetsComponent },
{ path: "kiera/zabbix", component: PageKieraZabbixComponent },
{ path: "kiera/zones", component: PageKieraZonesComponent },
{ path: "members", component: PageMembersComponent },
{ path: "mypage", component: PageMypageComponent },
{ path: "posts", component: PagePostsComponent },
{ path: "posts/:id/:tab?", component: PagePostsItemComponent }
] }
].map((layout: any) => ({
    ...layout,
    children: (layout.children || []).filter((child: any) => !isDisabledRoute(child.path))
}));

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    matcher: (url: any) => {
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children;
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }
